// Library document page: overview, contents (tree, clause detail, source preview), figures, tables, standards and thresholds, with the tab, clause and preview in the URL (S1).
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { booleanWithDefault, enumWithDefault, optionalString } from "@/app/search";
import { DOCUMENT_TABS, DocumentPage } from "@/features/library/DocumentPage";

const searchSchema = z.object({
  tab: enumWithDefault(DOCUMENT_TABS, "overview"),
  clause: optionalString(),
  preview: booleanWithDefault(false),
});

const searchDefaults = { tab: "overview", preview: false } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/$region/library/$docUid")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "Document" },
  component: DocumentRoute,
});

function DocumentRoute() {
  const { docUid } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DocumentPage
      docUid={docUid}
      search={search}
      onSearchChange={(next, options) => {
        void navigate({
          search: (previous) => ({ ...previous, ...next }),
          replace: options?.replace ?? false,
        });
      }}
    />
  );
}
